import { LineData, TickMarkType, UTCTimestamp } from 'lightweight-charts';

import { BacktesterPnlReportRow } from '../../../../../providers/backtesting/api/backtester-config-api.types';

export const toChartTimestamp = (value: string) =>
  Math.floor(new Date(value.replace(' ', 'T')).getTime() / 1000) as UTCTimestamp;

export const getNumericValue = (value: unknown) => {
  const numericValue = Number(value);
  return Number.isFinite(numericValue) ? numericValue : null;
};

export const getRowFieldNumber = (row: BacktesterPnlReportRow, field: string) =>
  getNumericValue(row[field]);

export const buildLineSeriesData = (
  reports: BacktesterPnlReportRow[],
  getValue: (row: BacktesterPnlReportRow) => number | null,
): LineData[] =>
  reports.reduce<LineData[]>((acc, row) => {
    if (!row.timestamp) return acc;
    const value = getValue(row);
    if (value == null) return acc;
    acc.push({
      time: toChartTimestamp(row.timestamp),
      value,
    });
    return acc;
  }, []);

export const formatTickMark = (time: UTCTimestamp, tickMarkType: TickMarkType) => {
  if (tickMarkType > TickMarkType.Month) return '';
  const date = new Date(time * 1000);
  const year = date.getUTCFullYear();
  const month = String(date.getUTCMonth() + 1).padStart(2, '0');
  return `${year}-${month}`;
};
